import logo from 'images/AWI Logo.jpg';
import React, { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

export function Logo(
  props: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> = {}
): React.ReactElement {
  return <img {...props} src={logo} />;
}
